export enum Mutation {
  SET_DRAWER = 'SET_DRAWER',
  SET_DRAWER_EVER_OPENED_STATE = 'SET_DRAWER_EVER_OPENED_STATE',
  SET_REQUEST_CLOSE = 'SET_REQUEST_CLOSE',
  SET_PREVENT_CLOSE = 'SET_PREVENT_CLOSE',
  SET_DRAWER_OPTIONS = 'SET_DRAWER_OPTIONS',
}
